/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 18th 2022, 7:36:37 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { Grid } from "@mui/material";
import { Container } from "@mui/material";
import Button from "@mui/material/Button";
import { COLORSCHEME } from "theme/styles";
import { useGlobalScope } from "core/providers";
import { URLS } from "core/routes";
import { useNavigate } from "react-router";
import Paper from "@mui/material/Paper";
import { StepContinueButton } from "./StepContinueButton";
import { useOnboardingContext } from "onboarding/providers/OnboardingProvider";
import { Image } from "ui-widgets";

export const SetupWelcomeStep = ({ label }) => {
  const globalScope = useGlobalScope();
  const { handleNextStep } = useOnboardingContext();
  const navigate = useNavigate();

  return (
    <div className="banner-content-intro banner-content-style-A">
      <Container maxWidth="sm">
        <div className="banner-style-A-stepper-wrapper">
          <Grid item lg={12}>
            <Paper elevation={0} className="os-organizations-setup-intro-image">
              <Image className="image-style-A" src="/img/illustration-1.png" alt="Welcome to Onestop Admin" />
            </Paper>
          </Grid>

          <h1 style={{ color: COLORSCHEME.primary }}>Welcome to the Onestop Admin Setup Wizard</h1>
          <p className="lead">
            Get started by setting up your organization and portal. Once done, you can start automating services for
            your organization.
          </p>
          <div className="banner-cta-style-A">
            <Grid container spacing={3} columns={12}>
              <Grid item xs={12} className="button-center">
                <StepContinueButton onClick={handleNextStep} continueText="Get Started" />
              </Grid>
              {globalScope.globalState.selectedOrganization && (
                <Grid item xs={12} className="button-center">
                  <Button
                    variant="text"
                    className="cta-style-A"
                    size="large"
                    color="primary"
                    onClick={() => navigate(URLS.dashboard)}
                  >
                    Back to Dashboard
                  </Button>
                </Grid>
              )}
            </Grid>
          </div>
        </div>
      </Container>

      <div className="banner-content-style-A-footer">
        <div className="footer-logo-style-A">
          <img className="image-style-B footer-A-logo" src="/img/onestop-symbol-in-circle.svg" alt="OneStop" />
        </div>
      </div>
    </div>
  );
};
